import { ReactElement, useEffect, useState } from 'react';
import { Box } from '@mui/material';

import { EPOCH_DURATION, EPOCH_START_TIMESTAMP } from 'modules/common';

function formatTime(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  return `${hours}h : ${minutes}m : ${remainingSeconds}s`;
}

export function EpochTimer(): ReactElement {
  const currentTimestamp = Math.floor(Date.now() / 1000);
  const secondsToNextEpoch =
    EPOCH_DURATION -
    ((currentTimestamp - EPOCH_START_TIMESTAMP) % EPOCH_DURATION);

  const [seconds, setSeconds] = useState(secondsToNextEpoch);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (seconds > 0) {
        setSeconds(prevSeconds => prevSeconds - 1);
      } else setSeconds(EPOCH_DURATION);
    }, 1000);

    return () => clearTimeout(timer);
  }, [seconds]);

  return <Box sx={{ minWidth: 'min-content' }}>{formatTime(seconds)}</Box>;
}
